<template>
    <div class="standart_mem clr">
        
        <b-container fluid>
            <h1 class="title text-center pt-5 pb-5 mt-5">{{title}} </h1>
            
            <div class="quest">щодо
                <span>{{quest_title}}</span>
            </div>
            
            <b-row class="doc_title" v-if="is_active_title">
                <b-col sm="3">
                    <label for="doc_title">тема (коротка назва) *</label>
                </b-col>
                <b-col sm="6">
                    <b-form-input class="fs-xl" :state="is_valid_title" v-model="mem_title"  maxlength="255" id="doc_title" size="sm" ></b-form-input>
                </b-col>
            </b-row>
            
            <slot name="after_title"></slot>
            
            <slot name="mem_preamblua">
                <b-row class="mem_create_row" v-if="is_active_preamblua">
                    <b-col sm="3">
                        <label>преамбула</label>
                    </b-col>
                    
                    <b-col sm="9">
                        <vue-editor :editor-toolbar="editor_rules"  id="preamblua" v-model="mem_preamblua"></vue-editor>
                    </b-col>
                </b-row>
            </slot>
            
            <b-row class="mem_create_row" v-if="is_active_problem">
                <b-col sm="3">
                    <label>проблема</label>
                </b-col>
                
                <b-col sm="9">
                    <vue-editor :editor-toolbar="editor_rules" id="problem" v-model="mem_problem"></vue-editor>
                </b-col>
            </b-row>
            
            
            <b-row class="mem_create_row" v-if="is_active_result">
                <b-col sm="3">
                    <label>запропоноване рішення</label>
                </b-col>
                
                <b-col sm="9">
                    <vue-editor  :editor-toolbar="editor_rules"  id="result" v-model="mem_result"></vue-editor>
                </b-col>
            </b-row>
            
            
            <b-row class="doc_title">
                <b-col sm="3">
                    <label for="reason_number">документ підстава (при наявності)</label>
                </b-col>
                
                <b-col sm="6">
                    <v-select multiple v-model="active_reasons"
                              @search="onSearch"
                              @input="push_reason_str"
                              class="imc_reasons"
                              label="number"
                              :filterable="false"
                              :options=multi_reasons  >
                        <template slot="no-options">
                            Починайте вводити номер службової
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.number }}
                                <small >{{option.title}}</small>
                            </div>
                        </template>
                    </v-select>
                </b-col>
            </b-row>
        
        </b-container>
    </div>



</template>

<script>
import vSelect from 'vue-select'
import { VueEditor } from "vue2-editor";
import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});


export default {
    name: "standart",
    
    components: {
        VueEditor,
        vSelect
    },
    
    props : {
        title: {
            type: String,
            default: "Службова записка №",
        },
        
        is_active_preamblua : {
            type : Boolean,
            default :true,
        },
        
        is_active_problem : {
            type : Boolean,
            default :true,
        },
        
        is_active_result : {
            type : Boolean,
            default :true,
        },
        
        is_active_title : {
            type : Boolean,
            default :true,
        },
    },
    
    data () {
        return {
            multi_reasons : [],
            active_reasons : [],
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
        }
    },
    
    methods: {
        onSearch(search, loading) {
            if(search.length > 2) {
                loading(true);
                this.search(loading, search);
            }
        },
        
        push_reason_str (cur_val) {
            let str = "";
            let nmb_str = [];
            
            this.active_reasons.map(item => {
                nmb_str.push(item.number);
            });
            this.reason_number = nmb_str.join(";");
        },
        
        async load_mem() {
        
        },
        
        async search(loading, search)  {
            await api.get('/memorandum/items/search/' + search).then(({data}) => {
                loading(false);
                this.multi_reasons =[];
                if(data.status == "operation_success") {
                    this.multi_reasons = data.data;
                }
                
            }).catch(err => {
                this.multi_reasons =[];
                loading(false);
            });
        }
    },
    
    computed: {
        
        ...mapFields([
            'active_memorandum'
        ]),
        
        current_addon() {
            return 'standart';
        },
        
        selected_mem () {
            return this.active_mem.form;
        },
        
        active_mem () {
            return this.active_memorandum;
        },
        
        mem_title :  {
            get() {
                return this.active_mem.title;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{title : value});
            }
        },
        
        reason_number : {
            get() {
                return this.active_mem.reason_number;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{reason_number : value});
            }
        },
        
        mem_preamblua : {
            get() {
                return this.active_mem.preamblua;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{preamblua : value});
            }
        },
        
        mem_problem : {
            get() {
                return this.active_mem.problem;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{problem : value});
            }
        },
        
        mem_result : {
            get() {
                return this.active_memorandum.result;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{result : value});
            }
        },
        
        quest_title  () {
            return this.active_mem.quest_data.title;
        },
        
        is_valid_title () {
            return this.mem_title.length > 3 && this.mem_title.length < 31;
        },
    },
}
</script>

<style scoped>

.ql-editor {
    min-height: 150px !important;
}
label {
    font-style: italic;
    font-size: 15px;
}


</style>

<style>
.imc_reasons .vs__dropdown-toggle {
    height :auto !important;
}

</style>
